import {
  CSSObjectWithLabel,
  ControlProps,
  DropdownIndicatorProps,
  OptionProps,
  StylesConfig,
  ValueContainerProps,
} from 'react-select';
import styled from 'styled-components';

import { SelectInput } from 'components/SelectInput';
import { colors, transition } from 'theme';

import { OptionType } from './Select.types';

export const StyledSelectInput = styled(SelectInput)`
  height: 50px;
  padding: 0 calc(12px - 2px);
  border-radius: 8px;
  border: 1px solid ${colors.selectionGrey};
  color: ${colors.brandBlue};
`;

export const selectStyles: StylesConfig<OptionType> = {
  control: (base: CSSObjectWithLabel, state: ControlProps<OptionType>) => ({
    ...base,
    borderRadius: '8px',
    backgroundColor: 'white',
    width: '100%',
    minHeight: '45px',
    margin: '0',
    cursor: 'pointer',
    borderColor: state.isFocused ? colors.brandBlue : colors.elementGrey,
  }),
  dropdownIndicator: (
    base: CSSObjectWithLabel,
    state: DropdownIndicatorProps<{ label: string; value: string }>,
  ) => ({
    ...base,
    color: state.selectProps.menuIsOpen
      ? colors.brandBlue
      : colors.lightContentGrey,
    paddingLeft: state.selectProps.menuIsOpen ? '19px' : undefined,
    paddingRight: state.selectProps.menuIsOpen ? undefined : '19px',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    height: '100%',
    paddingLeft: '0',
  }),
  valueContainer: (
    base: CSSObjectWithLabel,
    state: ValueContainerProps<OptionType>,
  ) => ({
    ...base,
    display: 'flex',
    padding: state.hasValue && state.isMulti ? '2px 12px' : '0 12px',
    alignItems: 'center',
  }),
  indicatorsContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    paddingTop: '2px',
  }),
  indicatorSeparator: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'none',
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    color: colors.mediumContentGrey,
    fontSize: '18px',
    margin: '0',
    maxWidth: 'calc(100% - 15px)',
  }),
  multiValue: (base: CSSObjectWithLabel) => ({
    ...base,
    background: colors.inputGrey,
    color: colors.brandBlue,
  }),
  multiValueLabel: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'inherit',
  }),
  multiValueRemove: (base: CSSObjectWithLabel) => ({
    ...base,
    borderRadius: '0 2px 2px 0',
    transition: `all ${transition}`,
    ':hover': {
      background: colors.brandBlue,
      color: 'white',
    },
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: '5',
    marginTop: '1px',
    borderRadius: '0 0 8px 8px',
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.15)',
    border: 'solid 1px #c4c8cc',
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0',
  }),
  option: (base: CSSObjectWithLabel, state: OptionProps<OptionType>) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    borderBottom: 'solid 1px #c4c8cc',
    color: colors.mediumContentGrey,
    padding: '0 12px',
    minHeight: '45px',
    cursor: 'pointer',
    backgroundColor:
      state.isFocused || state.isSelected ? 'rgba(241, 241, 241, 1)' : 'none',
  }),
};

export const multiSelectStyles: StylesConfig<OptionType> = {
  container: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'block',
    width: '100%',
    minHeight: '45px',
    verticalAlign: 'middle',
    color: colors.mediumContentGrey,
    fontSize: '18px',
  }),
  control: (base: CSSObjectWithLabel) => ({
    ...base,
    borderRadius: '8px',
    backgroundColor: 'white',
    width: '100%',
    minHeight: '45px',
    margin: '0',
    cursor: 'pointer',
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    height: '100%',
    paddingLeft: '0',
  }),
  valueContainer: (
    base: CSSObjectWithLabel,
    state: ValueContainerProps<OptionType>,
  ) => ({
    ...base,
    display: 'flex',
    padding: state.hasValue && state.isMulti ? '2px 12px' : '0 12px',
    alignItems: 'center',
  }),
  indicatorsContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    paddingTop: '2px',
  }),
  indicatorSeparator: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'none',
  }),
  multiValue: (base: CSSObjectWithLabel) => ({
    ...base,
    background: colors.inputGrey,
    color: colors.brandBlue,
  }),
  multiValueLabel: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'inherit',
  }),
  multiValueRemove: (base: CSSObjectWithLabel) => ({
    ...base,
    borderRadius: '0 2px 2px 0',
    transition: `all ${transition}`,
    ':hover': {
      background: colors.brandBlue,
      color: 'white',
    },
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: '5',
    marginTop: '1px',
    borderRadius: '0 0 8px 8px',
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.15)',
    border: 'solid 1px #c4c8cc',
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0',
  }),
  option: (base: CSSObjectWithLabel, state: OptionProps<OptionType>) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    borderBottom: 'solid 1px #c4c8cc',
    color: colors.mediumContentGrey,
    padding: '0 12px',
    minHeight: '45px',
    cursor: 'pointer',
    fart: 'boy',
    backgroundColor:
      state.isFocused || state.isSelected ? 'rgba(241, 241, 241, 1)' : 'none',
  }),
};
